<template>
  <div class="new-transfer-feedback">
    <NavBar transparent sticky>
      <template #left>
        <ButtonIconFoundation
          :colors="closeButtonColors"
          label="Voltar"
          icon="EA0030"
          @click="goBack"
        />
      </template>
    </NavBar>
    <section class="new-transfer-feedback__content">
      <div v-if="isWithoutBank" class="new-transfer-feedback__without-bank">
        <InitialAvatarIcon icon="BA0130" size="large" />
        <Heading :level="3">Adicione sua conta bancária</Heading>
        <BaseText size="md" :color="NebraskaColors.baseSecondary">
          Para transferir, você precisa ter uma conta bancária cadastrada. Para
          cadastrar, selecione <b>Dados Cadastrais</b> e em seguida a opção
          <b>Dados Bancários</b>.
        </BaseText>
      </div>
      <HelperViewStatus
        v-else
        :status="handleError.status"
        :title="handleError.title"
        :description="handleError.description"
        :button-label="handleError.buttonLabel"
        @click="emitReload"
      />
    </section>
    <ButtonContainer
      v-if="!isGenericError"
      class="new-transfer-feedback__button-container"
    >
      <template #button-primary>
        <ButtonPrimary
          size="large"
          :label="buttonPrimaryLabel"
          @click="buttonAction"
        />
      </template>
      <template v-if="isWithoutBank" #button-secondary>
        <ButtonSecondary
          size="large"
          label="Voltar para a home"
          @click="goHome"
        />
      </template>
    </ButtonContainer>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {
  NavBar,
  ButtonIconFoundation,
  InitialAvatarIcon,
  Heading,
  BaseText,
  HelperViewStatus,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { EFeedbackType } from '@/modules/transaction/views/NewTransfer/helpers/types';
@Component({
  components: {
    NavBar,
    ButtonIconFoundation,
    InitialAvatarIcon,
    Heading,
    BaseText,
    HelperViewStatus,
    ButtonContainer,
    ButtonPrimary,
    ButtonSecondary
  }
})
export default class NewTransferFeedback extends Vue {
  @Prop({ type: String, required: true })
  readonly feedbackType!: EFeedbackType;

  @Emit('reload')
  emitReload() {
    // Em caso de Erro, emite um evento para chamar a rota novamente
  }

  readonly NebraskaColors = NebraskaColors;

  get isWithoutBank() {
    return this.feedbackType === EFeedbackType.WITHOUT_BANK;
  }

  get isGenericError() {
    return this.feedbackType === EFeedbackType.GENERIC_ERROR;
  }

  get handleError() {
    return {
      status: 'alert',
      title: 'Houve um problema ao carregar os dados de conta',
      description: 'Aguarde um momento e tente novamente',
      buttonLabel: 'Tentar novamente'
    };
  }

  get closeButtonColors() {
    return {
      background: NebraskaColors.elementSecondary,
      content: NebraskaColors.elementPrimary,
      alphas: {
        default: 0,
        hover: 0.08,
        active: 0.08
      }
    };
  }

  get buttonPrimaryLabel() {
    return this.isWithoutBank
      ? 'Ir para Dados Cadastrais'
      : 'Voltar para a home';
  }

  buttonAction() {
    return this.isWithoutBank ? this.goUserAccount() : this.goHome();
  }

  goHome() {
    this.$router.push({ name: 'home' });
  }

  goUserAccount() {
    this.$router.push({ name: 'user-account' });
  }

  goBack() {
    this.$router.back();
  }
}
</script>

<style lang="less" scoped>
.new-transfer-feedback {
  height: 100vh;
  &__content {
    height: calc(100% - (64px + 97px));
    padding: 0 20%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__without-bank {
    max-width: 410px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .initial-avatar-icon {
      color: @element-primary;
      background-color: @neutral-secondary;
      margin-bottom: @size-spacing-x400;
    }
    .heading {
      margin-bottom: @size-spacing-x300;
    }
    .base-text {
      text-align: center;
    }
  }
  &__button-container {
    background-color: @background-secondary;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 20;
  }
  .helper-view {
    max-width: 376px;
  }
}
</style>
